'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var agedUnivercity = function agedUnivercity() {
  return import('@/page/specialPage/aged-univercity');
};
exports.default = [{
  path: '/agedUnivercity',
  name: 'agedUnivercity',
  component: agedUnivercity
}];